import { logger } from '@amzn/atoz-shiftapp-metrics';
import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { GenericErrorView } from '../../../shared';
import { useTranslation } from 'react-i18next';
export var WeeklyScheduleViewErrorBoundary = function (_a) {
    var children = _a.children;
    var t = useTranslation().t;
    var onError = function (error, info) {
        logger.emitError("JS Fatal, ".concat(error.message), {
            error: error,
            context: {
                info: info
            }
        });
    };
    return (React.createElement(ReactErrorBoundary, { onError: onError, fallbackRender: function (_a) {
            var resetErrorBoundary = _a.resetErrorBoundary;
            return (React.createElement(GenericErrorView, { bodyText: t('ess_shifts_dashboard_calendar_errorMessage'), buttonAction: resetErrorBoundary, dataTestId: "weekly-schedule-error-boundary" }));
        } }, children));
};
